import { Typography, Box } from '@mui/material'
import React from 'react'

const CustomTypography = ({
    variant,
    label,
    component,
    required,
    children,
    ...rest
}) => {
    let displayLabel = label;
    let isRequired = Boolean(required);

    if (typeof label === 'string' && /\s*\*+\s*$/.test(label)) {
        displayLabel = label.replace(/\s*\*+\s*$/, '');
        isRequired = true;
    }

    return (
        <Typography 
            variant={variant} 
            gutterBottom 
            component={component}
            {...rest}
        >
            {displayLabel ?? children}
            {isRequired && (
                <Box component="span" sx={{ color: '#d32f2f', ml: 0.5, fontWeight: 'bold' }}>
                    *
                </Box>
            )}
        </Typography>
    )
}

export default CustomTypography

